import { EditBase } from "../shared/edit.base";
import { Component, Inject } from "@angular/core";
import { SummationGroupDataService } from "../../core/summationgroups.dataservice";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "crew-edit-summationgroup",
    template: require('./summation-group.edit.component.html')
})
export class EditSummationGroup extends EditBase<Nema.Crew.Model.ActivityTypeSummationGroup> {

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject('summationGroup') entity: Nema.Crew.Model.ActivityTypeSummationGroup,
        @Inject(SummationGroupDataService.Id) summationGroupDataService: SummationGroupDataService,
        @Inject('$log') $log: ng.ILogService,
        @Inject('isNew') isNew: boolean) {

        super(stateService, transitionService, dialog, entity, summationGroupDataService, $log, isNew);
    }

    public entityDisplayName = "Activity Summation Group";

    public listStateName = "app.settings.summationgroups";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/summationgroups/summation-group.edit.component.ts